module.exports = __webpack_public_path__ + "assets/src/style/img/groningen-cultural-map.jpg?99e31c2ecd72b39aafd823c6a08f7d3a";